import _cloneDeep from "lodash/cloneDeep";
var _excluded = ["text", "url", "type", "size"],
  _excluded2 = ["text", "url", "type"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useContext } from 'react';
import classnames from 'classnames';
import { sanitizeContent } from "../../Utility/Utility";
import { TextPrice } from "../../Price/TextPrice/TextPrice";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { Button } from "../../Button/Button/Button";
import { ThemeContext } from "../../../context/theme.context";
import { Text } from "../../Text/Text/Text";
import { Image } from "../../Image/Image/Image";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import styles from "./IconItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var iconItemButton = ['primary', 'secondary', 'link'];
export var iconItemAlign = ['left', 'center'];
var iconSizes = ['small', 'medium', 'large'];
export var IconItem = function IconItem(_ref) {
  var align = _ref.align,
    button = _ref.button,
    cta = _ref.cta,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    errorMessage = _ref.errorMessage,
    _ref$features = _ref.features,
    features = _ref$features === void 0 ? '' : _ref$features,
    fileIconClass = _ref.fileIconClass,
    _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    iconSize = _ref.iconSize,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
    id = _ref.id,
    icon = _ref.icon,
    pricing = _ref.pricing,
    pricingText = _ref.pricingText,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm,
    textPrice = _ref.textPrice,
    _ref$processJSON = _ref.processJSON,
    processJSON = _ref$processJSON === void 0 ? false : _ref$processJSON;
  var theme = useContext(ThemeContext);
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var renderButton = function renderButton() {
    var text = button.text,
      url = button.url,
      type = button.type,
      size = button.size,
      otherProps = _objectWithoutProperties(button, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      url: url,
      type: type,
      size: "large"
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsx(Text, {
        richText: true,
        textElement: "span",
        typog: "bodycopy",
        className: styles.ctaText,
        children: text
      })
    }));
  };
  var renderCTA = function renderCTA() {
    var text = cta.text,
      url = cta.url,
      type = cta.type,
      otherProps = _objectWithoutProperties(cta, _excluded2);
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        className: styles.cta,
        url: url,
        type: "link"
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsx(Text, {
          richText: true,
          textElement: "span",
          typog: "bodycopy",
          className: styles.ctaText,
          children: text
        })
      }))
    });
  };
  var renderIcon = function renderIcon() {
    var iconSizes = {
      small: '48px',
      medium: '100px',
      large: '134px'
    };
    var size = iconSize ? iconSizes[iconSize] : '48px';
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.iconItemImage, styles["".concat(align, "Icon")], styles["".concat(iconSize, "Icon")]),
      children: /*#__PURE__*/_jsx(Image, {
        className: fileIconClass,
        alt: icon.alt || '',
        src: icon.image1x || '',
        width: size,
        height: size,
        loading: icon.loading || 'lazy'
      })
    });
  };
  var renderedPricing = pricing ? _cloneDeep(pricing) : false;
  if (renderedPricing && renderedPricing.input) {
    renderedPricing.input.className = styles.zipText;
    renderedPricing.input.autoFocus = autoFocus;
  }
  var showPrice = (textPrice === null || textPrice === void 0 ? void 0 : textPrice.text) && textPrice.price || pricingText;
  var hasButton = (button === null || button === void 0 ? void 0 : button.url) && button.text;
  var hasCTA = (cta === null || cta === void 0 ? void 0 : cta.url) && cta.text;
  var headingTextAdjustment = headline && processJSON ? sanitizeContent(headline) : headline;
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: classnames(styles.iconItem, {
      [styles.iconItemRow]: horizontal
    }),
    children: [/*#__PURE__*/_jsx(MatchHeightElement, {
      group: "icon",
      children: (icon === null || icon === void 0 ? void 0 : icon.image1x) && renderIcon() || /*#__PURE__*/_jsx("span", {})
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames({
        [styles[align || '']]: align,
        priceWrap: align === 'left'
      }),
      children: [/*#__PURE__*/_jsxs("div", {
        className: classnames(styles.iconItemContent, {
          [styles.iconItemContentMargin]: showPrice || hasButton || hasCTA
        }),
        children: [/*#__PURE__*/_jsx(MatchHeightElement, {
          group: "flag",
          children: flag && /*#__PURE__*/_jsx(Text, {
            richText: true,
            typog: "eyebrow3",
            children: flag
          }) || /*#__PURE__*/_jsx("span", {})
        }), /*#__PURE__*/_jsx(MatchHeightElement, {
          group: "headline",
          children: headingTextAdjustment && /*#__PURE__*/_jsx("div", {
            className: styles.iconItemHeadline,
            children: /*#__PURE__*/_jsx(Text, {
              richText: true,
              typog: "headline5",
              ariaLevel: 3,
              children: headingTextAdjustment
            })
          }) || /*#__PURE__*/_jsx("span", {})
        }), /*#__PURE__*/_jsx(MatchHeightElement, {
          group: "description",
          children: description && /*#__PURE__*/_jsx(Text, {
            className: classnames({
              [styles.iconItemDescription]: true,
              [styles.iconItemDescriptionDarkBackground]: theme === 'darkBackground'
            }),
            typog: "bodycopy",
            richText: true,
            children: description
          }) || /*#__PURE__*/_jsx("span", {})
        }), /*#__PURE__*/_jsx(MatchHeightElement, {
          group: "features",
          children: features && /*#__PURE__*/_jsx(Text, {
            className: classnames({
              [styles.iconItemFeatures]: true,
              [styles.iconItemFeaturesDarkBackground]: theme === 'darkBackground'
            }),
            typog: "bodycopySmall",
            richText: true,
            children: features
          }) || /*#__PURE__*/_jsx("span", {})
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames({
          [styles[align || '']]: align
        }),
        children: [showPrice && /*#__PURE__*/_jsx("div", {
          className: classnames({
            [styles.priceTextContainer]: true,
            [styles.priceTextDarkBackground]: !pricingText && theme === 'darkBackground'
          }),
          children: /*#__PURE__*/_jsxs(MatchHeightElement, {
            group: "price-text",
            children: [pricingText && /*#__PURE__*/_jsx(Text, {
              richText: true,
              textElement: "div",
              typog: "bodycopy",
              className: styles.pricingText,
              children: pricingText
            }) || /*#__PURE__*/_jsx("span", {}), !pricingText && /*#__PURE__*/_jsx(TextPrice, {
              text: textPrice.text,
              price: textPrice.price,
              className: styles.priceText,
              priceClass: styles.price,
              typogPriceText: "bodycopy"
            }) || /*#__PURE__*/_jsx("span", {})]
          })
        }), /*#__PURE__*/_jsx(MatchHeightElement, {
          group: "error",
          children: (errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.text) && /*#__PURE__*/_jsx(Text, {
            typog: "bodycopy",
            className: classnames(styles.iconItemError, {
              [styles[align || '']]: align,
              [styles.iconItemErrorRed]: errorMessage.red
            }),
            children: errorMessage.text
          }) || /*#__PURE__*/_jsx("span", {})
        }), /*#__PURE__*/_jsx(MatchHeightElement, {
          group: "pricing",
          children: hasButton && /*#__PURE__*/_jsxs("div", {
            className: classnames(styles.iconItemLink, {
              [styles.iconItemLinkMargin]: hasCTA
            }),
            children: [!showPricingForm && /*#__PURE__*/_jsx(MatchHeightElement, {
              group: "button",
              children: renderButton()
            }) || /*#__PURE__*/_jsx("span", {}), renderedPricing && /*#__PURE__*/_jsx(PricingForm, {
              pricing: renderedPricing,
              isOpen: showPricingForm,
              onZipClick: onZipClick
            }) || /*#__PURE__*/_jsx("span", {})]
          })
        }), hasCTA && renderCTA()]
      })]
    })]
  });
};